<template>
  <div class="search">
    <svg
      class="search__icon"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.875 18.75C15.2242 18.75 18.75 15.2242 18.75 10.875C18.75 6.52576 15.2242 3 10.875 3C6.52576 3 3 6.52576 3 10.875C3 15.2242 6.52576 18.75 10.875 18.75Z"
        stroke="#9BA2AB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.4438 16.4438L21.0001 21"
        stroke="#9BA2AB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <form action="#" @submit.prevent="submitForm">
      <input
        type="text"
        :placeholder="placeholder"
        v-model="searchText"
        @input="$emit('search-input', searchText)"
      />
    </form>
  </div>
</template>

<script>
export default {
  name: 'Search',
  props: {
    placeholder: {
      type: String,
      default: 'Поиск',
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searchText: '',
    };
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.searchText = newVal;
        }
      },
      immediate: true,
    },
  },
  methods: {
    submitForm() {
      this.$emit('findValue', this.searchText);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/styles/helpers/variables';
@import '../../assets/styles/helpers/mixin';

.search {
  position: relative;

  input {
    background: $backgroundInput;
    border: 1px solid #9ba2ab;
    box-sizing: border-box;
    border-radius: 0.8rem;
    height: 5rem;
    padding: 0 4rem;
    padding-left: 4.8rem;
    font-size: 1.6rem;
    line-height: 1.9rem;
    width: 100%;

    &::placeholder {
      color: #9ba2ab;
    }
  }

  &__icon {
    position: absolute;
    left: 1.5rem;
    top: 1.2rem;
    width: 2.4rem;
    height: 2.4rem;
  }
}
</style>
